import uniq from 'lodash/uniq'
import { getOverlappingIndicesList } from '.'

/**
 * 期間が重複している campaignBudget の index の配列
 */
const getOverlappingIndices = campaignBudgets =>
  uniq(
    getOverlappingIndicesList(campaignBudgets).reduce((acc, indices, index) => {
      acc = acc.concat(indices.length > 0 ? [index, ...indices] : [])
      return acc
    }, []),
  )

export default getOverlappingIndices
